module.exports = __webpack_public_path__ + "static/media/logo_text_bubble.e09bb1fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_text_bubble.svg
// module id = 79
// module chunks = 0